import angular from 'angular';
import Hebcal from 'hebcal';

let hebDateFilterModule = angular.module('hebDateFilter', [])
  .filter('hebDate', () => {
    return (date) => {
      var hebDate = new Hebcal.HDate(new Date(date)).toString('h');
      return hebDate;
    };
  })
  .name;

export default hebDateFilterModule;



// WEBPACK FOOTER //
// ./client/app/filters/heb-date.filter.js